var makeString = require('./helper/makeString');

module.exports = function swapCase(str) {
  return makeString(str).replace(/\S/g, function(c) {
    return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/swapCase.js
 ** module id = 1108
 ** module chunks = 0
 **/